<template>
  <dialog-add
    icon="hub"
    :title="$t('new_network')"
    is-fullscreen
    :is-on="true"
    :on-close="onCancel"
  >
    <template v-slot:content>
      <forms-tracking-network
        :on-cancel="onCancel"
        class="elevation-1"
        @saved="$emit('saved')"
      />
    </template>
  </dialog-add>
</template>

<script>
export default {
  emits: ['saved'],
  methods: {
    onCancel() {
      this.$router.push({ name: 'tracking-networks', query: this.$route.query });
    },
  },
};
</script>
